import { appClient } from './appClient';


export const getCaseTypes = appClient.functions.getCaseTypes;

export const generateCustomIds = appClient.functions.generateCustomIds;

export const autoGenerateId = appClient.functions.autoGenerateId;

export const setupDocumentSchema = appClient.functions.setupDocumentSchema;

export const documentManager = appClient.functions.documentManager;

export const executeDocumentSchema = appClient.functions.executeDocumentSchema;

export const addTestContact = appClient.functions.addTestContact;

export const getSupabaseContacts = appClient.functions.getSupabaseContacts;

export const createSupabaseContact = appClient.functions.createSupabaseContact;

export const getSupabaseContact = appClient.functions.getSupabaseContact;

export const updateSupabaseContact = appClient.functions.updateSupabaseContact;

export const getSupabaseCases = appClient.functions.getSupabaseCases;

export const getSupabaseCase = appClient.functions.getSupabaseCase;

export const createSupabaseCase = appClient.functions.createSupabaseCase;

export const updateSupabaseCase = appClient.functions.updateSupabaseCase;

export const linkContactToCase = appClient.functions.linkContactToCase;

export const getCaseContacts = appClient.functions.getCaseContacts;

export const linkDocumentToContact = appClient.functions.linkDocumentToContact;

export const getCaseDocuments = appClient.functions.getCaseDocuments;

export const setupSupabaseTables = appClient.functions.setupSupabaseTables;

export const setupSalesItemsTable = appClient.functions.setupSalesItemsTable;

export const testSupabase = appClient.functions.testSupabase;

export const addSalesItemColumn = appClient.functions.addSalesItemColumn;

export const migrateCaseTypesToSalesItems = appClient.functions.migrateCaseTypesToSalesItems;

export const createSalesItem = appClient.functions.createSalesItem;

export const getCases = appClient.functions.getCases;

export const getCase = appClient.functions.getCase;

export const createCase = appClient.functions.createCase;

export const updateCase = appClient.functions.updateCase;

export const addCaseContact = appClient.functions.addCaseContact;

export const removeCaseContact = appClient.functions.removeCaseContact;

export const getSalesItems = appClient.functions.getSalesItems;

export const getAllSalesItems = appClient.functions.getAllSalesItems;

export const updateSalesItem = appClient.functions.updateSalesItem;

export const deleteSalesItem = appClient.functions.deleteSalesItem;

export const testSalesItems = appClient.functions.testSalesItems;

export const checkCasesTable = appClient.functions.checkCasesTable;

export const getContactDocuments = appClient.functions.getContactDocuments;

export const uploadContactDocument = appClient.functions.uploadContactDocument;

export const verifySupabaseSchema = appClient.functions.verifySupabaseSchema;

export const uploadDocumentToStorage = appClient.functions.uploadDocumentToStorage;

export const getSupabaseConfig = appClient.functions.getSupabaseConfig;

export const setupDocumentsSchema = appClient.functions.setupDocumentsSchema;

export const storageProxy = appClient.functions.storageProxy;

export const setupCaseRolesSchema = appClient.functions.setupCaseRolesSchema;

export const getCasePayer = appClient.functions.getCasePayer;

export const testContactsSetup = appClient.functions.testContactsSetup;

export const sendWhatsAppMessage = appClient.functions.sendWhatsAppMessage;

export const whatsappWebhook = appClient.functions.whatsappWebhook;

export const getWhatsAppMessages = appClient.functions.getWhatsAppMessages;

export const setupWhatsAppTables = appClient.functions.setupWhatsAppTables;

export const getWhatsAppTablesSQL = appClient.functions.getWhatsAppTablesSQL;

export const processWhatsAppMedia = appClient.functions.processWhatsAppMedia;

export const TwilioInboundMessage = appClient.functions.TwilioInboundMessage;

export const TwilioStatusCallback = appClient.functions.TwilioStatusCallback;

export const addPointOfContactColumn = appClient.functions.addPointOfContactColumn;

export const assignUserToCase = appClient.functions.assignUserToCase;

export const getAllContacts = appClient.functions.getAllContacts;

export const testCaseContacts = appClient.functions.testCaseContacts;

export const getCaseDebug = appClient.functions.getCaseDebug;

export const getCasesSimple = appClient.functions.getCasesSimple;

export const getCaseAssignments = appClient.functions.getCaseAssignments;

export const debugUserAuth = appClient.functions.debugUserAuth;

export const fixCaseAssignmentsSchema = appClient.functions.fixCaseAssignmentsSchema;

export const compareUsers = appClient.functions.compareUsers;

export const syncUsersToSupabase = appClient.functions.syncUsersToSupabase;

export const getCaseWithDetails = appClient.functions.getCaseWithDetails;

export const debugCaseLoad = appClient.functions.debugCaseLoad;

export const debugCaseData = appClient.functions.debugCaseData;

export const createEmptySlot = appClient.functions.createEmptySlot;

export const addSlotLabelColumn = appClient.functions.addSlotLabelColumn;

export const assignContactToSlot = appClient.functions.assignContactToSlot;

export const removeRoleConstraint = appClient.functions.removeRoleConstraint;

export const allowNullContactId = appClient.functions.allowNullContactId;

export const updateCaseContact = appClient.functions.updateCaseContact;

